import { IList } from 'annotation-tools/utils';
import { Observable } from 'rxjs';
import { defaultCropRectRelative } from '../constants/default-crop-rect';
import { IBboxType, ILabelType } from '../imports/annotation-canvas';
import {
  IImage,
  IImageType,
  IRectType,
  useStreamValue
} from '../imports/utils';
import { AppMode } from '../types/enum/app-mode';

export const useExtractedValues = (
  bboxesRelative$: Observable<IList<IBboxType>>,
  image$: Observable<IImageType>,
  cropRectRelative$: Observable<IRectType>,
  selectedLabel$: Observable<ILabelType | undefined>,
  visibleLabels$: Observable<IList<ILabelType>>,
  currentPageIndex$: Observable<number>,
  helpDialogIsOpen$: Observable<boolean>,
  confirmDialogIsOpen$: Observable<boolean>,
  appMode$: Observable<AppMode>
) => {
  /* extract values */

  const bboxesRelativeToImage = useStreamValue(
    bboxesRelative$,
    IList<IBboxType>()
  );

  const image = useStreamValue(image$, IImage());
  const cropRectRelative = useStreamValue(
    cropRectRelative$,
    defaultCropRectRelative
  );

  const selectedLabel = useStreamValue(selectedLabel$);
  const visibleLabels = useStreamValue(visibleLabels$, IList());

  const currentPageIndex = useStreamValue(currentPageIndex$, 0);

  const helpDialogIsOpen = useStreamValue(helpDialogIsOpen$, false);
  const confirmDialogIsOpen = useStreamValue(confirmDialogIsOpen$, false);

  const appMode = useStreamValue(appMode$, 'crop-image');

  return {
    bboxesRelativeToImage,
    image,
    cropRectRelative,
    selectedLabel,
    visibleLabels,
    currentPageIndex,
    helpDialogIsOpen,
    confirmDialogIsOpen,
    appMode
  };
};
